export default "__VITE_ASSET__D5aQ70JD__"